/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * PanLuma API
 * Enterprise productivity application API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type { EInvoiceCustomerProfileResponse } from '../models/eInvoiceCustomerProfileResponse';

import type { EInvoiceCustomerProfileUpdateRequest } from '../models/eInvoiceCustomerProfileUpdateRequest';

import type { EInvoiceDocumentListResponse } from '../models/eInvoiceDocumentListResponse';

import type { EInvoiceDocumentNullableResponse } from '../models/eInvoiceDocumentNullableResponse';

import type { EInvoiceDocumentResponse } from '../models/eInvoiceDocumentResponse';

import type { EInvoiceValidationResponse } from '../models/eInvoiceValidationResponse';

import type { GetInvoicePdfApiV1AccountingInvoicesInvoiceIdPdfGetParams } from '../models/getInvoicePdfApiV1AccountingInvoicesInvoiceIdPdfGetParams';

import type { GetInvoicePreviewApiV1AccountingInvoicesInvoiceIdPreviewGetParams } from '../models/getInvoicePreviewApiV1AccountingInvoicesInvoiceIdPreviewGetParams';

import type { HTTPValidationError } from '../models/hTTPValidationError';

import type { InvoiceDistributeRequest } from '../models/invoiceDistributeRequest';

import type { InvoiceDistributeResponse } from '../models/invoiceDistributeResponse';

import type { InvoicePaymentLinkResponse } from '../models/invoicePaymentLinkResponse';

import type { PaymentIntentListResponse } from '../models/paymentIntentListResponse';

import { customInstance } from '../../../shared/api/axiosInstance';

/**
 * Generate and return a branded PDF for an invoice.

The ``lang`` query param selects the document language; when omitted it
defaults to the requesting user's preferred language.
 * @summary Get Invoice Pdf
 */
export const getInvoicePdfApiV1AccountingInvoicesInvoiceIdPdfGet = (
  invoiceId: string,
  params?: GetInvoicePdfApiV1AccountingInvoicesInvoiceIdPdfGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/invoices/${invoiceId}/pdf`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetInvoicePdfApiV1AccountingInvoicesInvoiceIdPdfGetQueryKey = (
  invoiceId?: string,
  params?: GetInvoicePdfApiV1AccountingInvoicesInvoiceIdPdfGetParams
) => {
  return [
    `/api/v1/accounting/invoices/${invoiceId}/pdf`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetInvoicePdfApiV1AccountingInvoicesInvoiceIdPdfGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getInvoicePdfApiV1AccountingInvoicesInvoiceIdPdfGet>
    >,
    TError = HTTPValidationError
  >(
    invoiceId: string,
    params?: GetInvoicePdfApiV1AccountingInvoicesInvoiceIdPdfGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getInvoicePdfApiV1AccountingInvoicesInvoiceIdPdfGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetInvoicePdfApiV1AccountingInvoicesInvoiceIdPdfGetQueryKey(
        invoiceId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getInvoicePdfApiV1AccountingInvoicesInvoiceIdPdfGet>
      >
    > = ({ signal }) =>
      getInvoicePdfApiV1AccountingInvoicesInvoiceIdPdfGet(
        invoiceId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!invoiceId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getInvoicePdfApiV1AccountingInvoicesInvoiceIdPdfGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetInvoicePdfApiV1AccountingInvoicesInvoiceIdPdfGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getInvoicePdfApiV1AccountingInvoicesInvoiceIdPdfGet>
    >
  >;
export type GetInvoicePdfApiV1AccountingInvoicesInvoiceIdPdfGetQueryError =
  HTTPValidationError;

export function useGetInvoicePdfApiV1AccountingInvoicesInvoiceIdPdfGet<
  TData = Awaited<
    ReturnType<typeof getInvoicePdfApiV1AccountingInvoicesInvoiceIdPdfGet>
  >,
  TError = HTTPValidationError
>(
  invoiceId: string,
  params: undefined | GetInvoicePdfApiV1AccountingInvoicesInvoiceIdPdfGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getInvoicePdfApiV1AccountingInvoicesInvoiceIdPdfGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getInvoicePdfApiV1AccountingInvoicesInvoiceIdPdfGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getInvoicePdfApiV1AccountingInvoicesInvoiceIdPdfGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetInvoicePdfApiV1AccountingInvoicesInvoiceIdPdfGet<
  TData = Awaited<
    ReturnType<typeof getInvoicePdfApiV1AccountingInvoicesInvoiceIdPdfGet>
  >,
  TError = HTTPValidationError
>(
  invoiceId: string,
  params?: GetInvoicePdfApiV1AccountingInvoicesInvoiceIdPdfGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getInvoicePdfApiV1AccountingInvoicesInvoiceIdPdfGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getInvoicePdfApiV1AccountingInvoicesInvoiceIdPdfGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getInvoicePdfApiV1AccountingInvoicesInvoiceIdPdfGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetInvoicePdfApiV1AccountingInvoicesInvoiceIdPdfGet<
  TData = Awaited<
    ReturnType<typeof getInvoicePdfApiV1AccountingInvoicesInvoiceIdPdfGet>
  >,
  TError = HTTPValidationError
>(
  invoiceId: string,
  params?: GetInvoicePdfApiV1AccountingInvoicesInvoiceIdPdfGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getInvoicePdfApiV1AccountingInvoicesInvoiceIdPdfGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Invoice Pdf
 */

export function useGetInvoicePdfApiV1AccountingInvoicesInvoiceIdPdfGet<
  TData = Awaited<
    ReturnType<typeof getInvoicePdfApiV1AccountingInvoicesInvoiceIdPdfGet>
  >,
  TError = HTTPValidationError
>(
  invoiceId: string,
  params?: GetInvoicePdfApiV1AccountingInvoicesInvoiceIdPdfGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getInvoicePdfApiV1AccountingInvoicesInvoiceIdPdfGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetInvoicePdfApiV1AccountingInvoicesInvoiceIdPdfGetQueryOptions(
      invoiceId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Generate preview HTML for an invoice (for browser rendering).

The ``lang`` query param selects the document language; when omitted it
defaults to the requesting user's preferred language.
 * @summary Get Invoice Preview
 */
export const getInvoicePreviewApiV1AccountingInvoicesInvoiceIdPreviewGet = (
  invoiceId: string,
  params?: GetInvoicePreviewApiV1AccountingInvoicesInvoiceIdPreviewGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/accounting/invoices/${invoiceId}/preview`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetInvoicePreviewApiV1AccountingInvoicesInvoiceIdPreviewGetQueryKey =
  (
    invoiceId?: string,
    params?: GetInvoicePreviewApiV1AccountingInvoicesInvoiceIdPreviewGetParams
  ) => {
    return [
      `/api/v1/accounting/invoices/${invoiceId}/preview`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetInvoicePreviewApiV1AccountingInvoicesInvoiceIdPreviewGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getInvoicePreviewApiV1AccountingInvoicesInvoiceIdPreviewGet
      >
    >,
    TError = HTTPValidationError
  >(
    invoiceId: string,
    params?: GetInvoicePreviewApiV1AccountingInvoicesInvoiceIdPreviewGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getInvoicePreviewApiV1AccountingInvoicesInvoiceIdPreviewGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetInvoicePreviewApiV1AccountingInvoicesInvoiceIdPreviewGetQueryKey(
        invoiceId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getInvoicePreviewApiV1AccountingInvoicesInvoiceIdPreviewGet
        >
      >
    > = ({ signal }) =>
      getInvoicePreviewApiV1AccountingInvoicesInvoiceIdPreviewGet(
        invoiceId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!invoiceId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getInvoicePreviewApiV1AccountingInvoicesInvoiceIdPreviewGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetInvoicePreviewApiV1AccountingInvoicesInvoiceIdPreviewGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getInvoicePreviewApiV1AccountingInvoicesInvoiceIdPreviewGet
      >
    >
  >;
export type GetInvoicePreviewApiV1AccountingInvoicesInvoiceIdPreviewGetQueryError =
  HTTPValidationError;

export function useGetInvoicePreviewApiV1AccountingInvoicesInvoiceIdPreviewGet<
  TData = Awaited<
    ReturnType<
      typeof getInvoicePreviewApiV1AccountingInvoicesInvoiceIdPreviewGet
    >
  >,
  TError = HTTPValidationError
>(
  invoiceId: string,
  params:
    | undefined
    | GetInvoicePreviewApiV1AccountingInvoicesInvoiceIdPreviewGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getInvoicePreviewApiV1AccountingInvoicesInvoiceIdPreviewGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getInvoicePreviewApiV1AccountingInvoicesInvoiceIdPreviewGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getInvoicePreviewApiV1AccountingInvoicesInvoiceIdPreviewGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetInvoicePreviewApiV1AccountingInvoicesInvoiceIdPreviewGet<
  TData = Awaited<
    ReturnType<
      typeof getInvoicePreviewApiV1AccountingInvoicesInvoiceIdPreviewGet
    >
  >,
  TError = HTTPValidationError
>(
  invoiceId: string,
  params?: GetInvoicePreviewApiV1AccountingInvoicesInvoiceIdPreviewGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getInvoicePreviewApiV1AccountingInvoicesInvoiceIdPreviewGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getInvoicePreviewApiV1AccountingInvoicesInvoiceIdPreviewGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getInvoicePreviewApiV1AccountingInvoicesInvoiceIdPreviewGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetInvoicePreviewApiV1AccountingInvoicesInvoiceIdPreviewGet<
  TData = Awaited<
    ReturnType<
      typeof getInvoicePreviewApiV1AccountingInvoicesInvoiceIdPreviewGet
    >
  >,
  TError = HTTPValidationError
>(
  invoiceId: string,
  params?: GetInvoicePreviewApiV1AccountingInvoicesInvoiceIdPreviewGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getInvoicePreviewApiV1AccountingInvoicesInvoiceIdPreviewGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Invoice Preview
 */

export function useGetInvoicePreviewApiV1AccountingInvoicesInvoiceIdPreviewGet<
  TData = Awaited<
    ReturnType<
      typeof getInvoicePreviewApiV1AccountingInvoicesInvoiceIdPreviewGet
    >
  >,
  TError = HTTPValidationError
>(
  invoiceId: string,
  params?: GetInvoicePreviewApiV1AccountingInvoicesInvoiceIdPreviewGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getInvoicePreviewApiV1AccountingInvoicesInvoiceIdPreviewGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetInvoicePreviewApiV1AccountingInvoicesInvoiceIdPreviewGetQueryOptions(
      invoiceId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a public "Pay this invoice" link backed by the tenant's gateway.

Returns the absolute pay URL plus the single-use token; funds settle to the
tenant's connected account when the customer pays on Stripe's hosted page.
 * @summary Create Invoice Payment Link
 */
export const createInvoicePaymentLinkApiV1AccountingInvoicesInvoiceIdPaymentLinkPost =
  (invoiceId: string, signal?: AbortSignal) => {
    return customInstance<InvoicePaymentLinkResponse>({
      url: `/api/v1/accounting/invoices/${invoiceId}/payment-link`,
      method: 'POST',
      signal
    });
  };

export const getCreateInvoicePaymentLinkApiV1AccountingInvoicesInvoiceIdPaymentLinkPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createInvoicePaymentLinkApiV1AccountingInvoicesInvoiceIdPaymentLinkPost
        >
      >,
      TError,
      { invoiceId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createInvoicePaymentLinkApiV1AccountingInvoicesInvoiceIdPaymentLinkPost
      >
    >,
    TError,
    { invoiceId: string },
    TContext
  > => {
    const mutationKey = [
      'createInvoicePaymentLinkApiV1AccountingInvoicesInvoiceIdPaymentLinkPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createInvoicePaymentLinkApiV1AccountingInvoicesInvoiceIdPaymentLinkPost
        >
      >,
      { invoiceId: string }
    > = (props) => {
      const { invoiceId } = props ?? {};

      return createInvoicePaymentLinkApiV1AccountingInvoicesInvoiceIdPaymentLinkPost(
        invoiceId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateInvoicePaymentLinkApiV1AccountingInvoicesInvoiceIdPaymentLinkPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createInvoicePaymentLinkApiV1AccountingInvoicesInvoiceIdPaymentLinkPost
      >
    >
  >;

export type CreateInvoicePaymentLinkApiV1AccountingInvoicesInvoiceIdPaymentLinkPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Invoice Payment Link
 */
export const useCreateInvoicePaymentLinkApiV1AccountingInvoicesInvoiceIdPaymentLinkPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createInvoicePaymentLinkApiV1AccountingInvoicesInvoiceIdPaymentLinkPost
          >
        >,
        TError,
        { invoiceId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createInvoicePaymentLinkApiV1AccountingInvoicesInvoiceIdPaymentLinkPost
      >
    >,
    TError,
    { invoiceId: string },
    TContext
  > => {
    const mutationOptions =
      getCreateInvoicePaymentLinkApiV1AccountingInvoicesInvoiceIdPaymentLinkPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List the card-collection attempts (intents) recorded for an invoice.
 * @summary List Invoice Payment Intents
 */
export const listInvoicePaymentIntentsApiV1AccountingInvoicesInvoiceIdPaymentIntentsGet =
  (invoiceId: string, signal?: AbortSignal) => {
    return customInstance<PaymentIntentListResponse>({
      url: `/api/v1/accounting/invoices/${invoiceId}/payment-intents`,
      method: 'GET',
      signal
    });
  };

export const getListInvoicePaymentIntentsApiV1AccountingInvoicesInvoiceIdPaymentIntentsGetQueryKey =
  (invoiceId?: string) => {
    return [
      `/api/v1/accounting/invoices/${invoiceId}/payment-intents`
    ] as const;
  };

export const getListInvoicePaymentIntentsApiV1AccountingInvoicesInvoiceIdPaymentIntentsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listInvoicePaymentIntentsApiV1AccountingInvoicesInvoiceIdPaymentIntentsGet
      >
    >,
    TError = HTTPValidationError
  >(
    invoiceId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listInvoicePaymentIntentsApiV1AccountingInvoicesInvoiceIdPaymentIntentsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListInvoicePaymentIntentsApiV1AccountingInvoicesInvoiceIdPaymentIntentsGetQueryKey(
        invoiceId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listInvoicePaymentIntentsApiV1AccountingInvoicesInvoiceIdPaymentIntentsGet
        >
      >
    > = ({ signal }) =>
      listInvoicePaymentIntentsApiV1AccountingInvoicesInvoiceIdPaymentIntentsGet(
        invoiceId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!invoiceId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listInvoicePaymentIntentsApiV1AccountingInvoicesInvoiceIdPaymentIntentsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListInvoicePaymentIntentsApiV1AccountingInvoicesInvoiceIdPaymentIntentsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listInvoicePaymentIntentsApiV1AccountingInvoicesInvoiceIdPaymentIntentsGet
      >
    >
  >;
export type ListInvoicePaymentIntentsApiV1AccountingInvoicesInvoiceIdPaymentIntentsGetQueryError =
  HTTPValidationError;

export function useListInvoicePaymentIntentsApiV1AccountingInvoicesInvoiceIdPaymentIntentsGet<
  TData = Awaited<
    ReturnType<
      typeof listInvoicePaymentIntentsApiV1AccountingInvoicesInvoiceIdPaymentIntentsGet
    >
  >,
  TError = HTTPValidationError
>(
  invoiceId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listInvoicePaymentIntentsApiV1AccountingInvoicesInvoiceIdPaymentIntentsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listInvoicePaymentIntentsApiV1AccountingInvoicesInvoiceIdPaymentIntentsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listInvoicePaymentIntentsApiV1AccountingInvoicesInvoiceIdPaymentIntentsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListInvoicePaymentIntentsApiV1AccountingInvoicesInvoiceIdPaymentIntentsGet<
  TData = Awaited<
    ReturnType<
      typeof listInvoicePaymentIntentsApiV1AccountingInvoicesInvoiceIdPaymentIntentsGet
    >
  >,
  TError = HTTPValidationError
>(
  invoiceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listInvoicePaymentIntentsApiV1AccountingInvoicesInvoiceIdPaymentIntentsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listInvoicePaymentIntentsApiV1AccountingInvoicesInvoiceIdPaymentIntentsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listInvoicePaymentIntentsApiV1AccountingInvoicesInvoiceIdPaymentIntentsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListInvoicePaymentIntentsApiV1AccountingInvoicesInvoiceIdPaymentIntentsGet<
  TData = Awaited<
    ReturnType<
      typeof listInvoicePaymentIntentsApiV1AccountingInvoicesInvoiceIdPaymentIntentsGet
    >
  >,
  TError = HTTPValidationError
>(
  invoiceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listInvoicePaymentIntentsApiV1AccountingInvoicesInvoiceIdPaymentIntentsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Invoice Payment Intents
 */

export function useListInvoicePaymentIntentsApiV1AccountingInvoicesInvoiceIdPaymentIntentsGet<
  TData = Awaited<
    ReturnType<
      typeof listInvoicePaymentIntentsApiV1AccountingInvoicesInvoiceIdPaymentIntentsGet
    >
  >,
  TError = HTTPValidationError
>(
  invoiceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listInvoicePaymentIntentsApiV1AccountingInvoicesInvoiceIdPaymentIntentsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListInvoicePaymentIntentsApiV1AccountingInvoicesInvoiceIdPaymentIntentsGetQueryOptions(
      invoiceId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Email a branded invoice/credit-note to the customer (and re-share).

Each call is its own tracked distribution event, so re-sharing is just
calling this again. Recipients default to the invoice's contact when ``to``
is omitted. Delegates to the generic shared distribution service.
 * @summary Distribute Invoice
 */
export const distributeInvoiceApiV1AccountingInvoicesInvoiceIdDistributePost = (
  invoiceId: string,
  invoiceDistributeRequest: InvoiceDistributeRequest,
  signal?: AbortSignal
) => {
  return customInstance<InvoiceDistributeResponse>({
    url: `/api/v1/accounting/invoices/${invoiceId}/distribute`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: invoiceDistributeRequest,
    signal
  });
};

export const getDistributeInvoiceApiV1AccountingInvoicesInvoiceIdDistributePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof distributeInvoiceApiV1AccountingInvoicesInvoiceIdDistributePost
        >
      >,
      TError,
      { invoiceId: string; data: InvoiceDistributeRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof distributeInvoiceApiV1AccountingInvoicesInvoiceIdDistributePost
      >
    >,
    TError,
    { invoiceId: string; data: InvoiceDistributeRequest },
    TContext
  > => {
    const mutationKey = [
      'distributeInvoiceApiV1AccountingInvoicesInvoiceIdDistributePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof distributeInvoiceApiV1AccountingInvoicesInvoiceIdDistributePost
        >
      >,
      { invoiceId: string; data: InvoiceDistributeRequest }
    > = (props) => {
      const { invoiceId, data } = props ?? {};

      return distributeInvoiceApiV1AccountingInvoicesInvoiceIdDistributePost(
        invoiceId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DistributeInvoiceApiV1AccountingInvoicesInvoiceIdDistributePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof distributeInvoiceApiV1AccountingInvoicesInvoiceIdDistributePost
      >
    >
  >;
export type DistributeInvoiceApiV1AccountingInvoicesInvoiceIdDistributePostMutationBody =
  InvoiceDistributeRequest;
export type DistributeInvoiceApiV1AccountingInvoicesInvoiceIdDistributePostMutationError =
  HTTPValidationError;

/**
 * @summary Distribute Invoice
 */
export const useDistributeInvoiceApiV1AccountingInvoicesInvoiceIdDistributePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof distributeInvoiceApiV1AccountingInvoicesInvoiceIdDistributePost
          >
        >,
        TError,
        { invoiceId: string; data: InvoiceDistributeRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof distributeInvoiceApiV1AccountingInvoicesInvoiceIdDistributePost
      >
    >,
    TError,
    { invoiceId: string; data: InvoiceDistributeRequest },
    TContext
  > => {
    const mutationOptions =
      getDistributeInvoiceApiV1AccountingInvoicesInvoiceIdDistributePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Generate the UBL 2.1 / PEPPOL BIS e-invoice for an AR invoice.

Idempotent: an unchanged invoice re-renders to the same bytes and the existing
document is returned. A malformed invoice fails with 422 and the list of EN
16931 / PEPPOL rule violations in ``details.violations`` — each naming the
field and the fix.
 * @summary Generate Einvoice
 */
export const generateEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoicePost = (
  invoiceId: string,
  signal?: AbortSignal
) => {
  return customInstance<EInvoiceDocumentResponse>({
    url: `/api/v1/accounting/invoices/${invoiceId}/einvoice`,
    method: 'POST',
    signal
  });
};

export const getGenerateEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoicePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof generateEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoicePost
        >
      >,
      TError,
      { invoiceId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof generateEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoicePost
      >
    >,
    TError,
    { invoiceId: string },
    TContext
  > => {
    const mutationKey = [
      'generateEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoicePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof generateEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoicePost
        >
      >,
      { invoiceId: string }
    > = (props) => {
      const { invoiceId } = props ?? {};

      return generateEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoicePost(
        invoiceId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type GenerateEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoicePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof generateEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoicePost
      >
    >
  >;

export type GenerateEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoicePostMutationError =
  HTTPValidationError;

/**
 * @summary Generate Einvoice
 */
export const useGenerateEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoicePost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof generateEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoicePost
        >
      >,
      TError,
      { invoiceId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof generateEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoicePost
    >
  >,
  TError,
  { invoiceId: string },
  TContext
> => {
  const mutationOptions =
    getGenerateEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoicePostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Return the most recent e-invoice document generated for an invoice.

``data`` is null when none has been generated yet — a routine state (the
invoice detail page polls this on every view), not a 404, so it produces no
client-side error noise.
 * @summary Get Einvoice
 */
export const getEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoiceGet = (
  invoiceId: string,
  signal?: AbortSignal
) => {
  return customInstance<EInvoiceDocumentNullableResponse>({
    url: `/api/v1/accounting/invoices/${invoiceId}/einvoice`,
    method: 'GET',
    signal
  });
};

export const getGetEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoiceGetQueryKey =
  (invoiceId?: string) => {
    return [`/api/v1/accounting/invoices/${invoiceId}/einvoice`] as const;
  };

export const getGetEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoiceGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoiceGet>
    >,
    TError = HTTPValidationError
  >(
    invoiceId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoiceGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoiceGetQueryKey(
        invoiceId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoiceGet
        >
      >
    > = ({ signal }) =>
      getEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoiceGet(invoiceId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!invoiceId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoiceGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoiceGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoiceGet>
    >
  >;
export type GetEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoiceGetQueryError =
  HTTPValidationError;

export function useGetEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoiceGet<
  TData = Awaited<
    ReturnType<typeof getEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoiceGet>
  >,
  TError = HTTPValidationError
>(
  invoiceId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoiceGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoiceGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoiceGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoiceGet<
  TData = Awaited<
    ReturnType<typeof getEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoiceGet>
  >,
  TError = HTTPValidationError
>(
  invoiceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoiceGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoiceGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoiceGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoiceGet<
  TData = Awaited<
    ReturnType<typeof getEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoiceGet>
  >,
  TError = HTTPValidationError
>(
  invoiceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoiceGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Einvoice
 */

export function useGetEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoiceGet<
  TData = Awaited<
    ReturnType<typeof getEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoiceGet>
  >,
  TError = HTTPValidationError
>(
  invoiceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoiceGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoiceGetQueryOptions(
      invoiceId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List every e-invoice document emitted for an invoice, newest first.
 * @summary List Einvoice Documents
 */
export const listEinvoiceDocumentsApiV1AccountingInvoicesInvoiceIdEinvoiceDocumentsGet =
  (invoiceId: string, signal?: AbortSignal) => {
    return customInstance<EInvoiceDocumentListResponse>({
      url: `/api/v1/accounting/invoices/${invoiceId}/einvoice/documents`,
      method: 'GET',
      signal
    });
  };

export const getListEinvoiceDocumentsApiV1AccountingInvoicesInvoiceIdEinvoiceDocumentsGetQueryKey =
  (invoiceId?: string) => {
    return [
      `/api/v1/accounting/invoices/${invoiceId}/einvoice/documents`
    ] as const;
  };

export const getListEinvoiceDocumentsApiV1AccountingInvoicesInvoiceIdEinvoiceDocumentsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listEinvoiceDocumentsApiV1AccountingInvoicesInvoiceIdEinvoiceDocumentsGet
      >
    >,
    TError = HTTPValidationError
  >(
    invoiceId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listEinvoiceDocumentsApiV1AccountingInvoicesInvoiceIdEinvoiceDocumentsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListEinvoiceDocumentsApiV1AccountingInvoicesInvoiceIdEinvoiceDocumentsGetQueryKey(
        invoiceId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listEinvoiceDocumentsApiV1AccountingInvoicesInvoiceIdEinvoiceDocumentsGet
        >
      >
    > = ({ signal }) =>
      listEinvoiceDocumentsApiV1AccountingInvoicesInvoiceIdEinvoiceDocumentsGet(
        invoiceId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!invoiceId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listEinvoiceDocumentsApiV1AccountingInvoicesInvoiceIdEinvoiceDocumentsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListEinvoiceDocumentsApiV1AccountingInvoicesInvoiceIdEinvoiceDocumentsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listEinvoiceDocumentsApiV1AccountingInvoicesInvoiceIdEinvoiceDocumentsGet
      >
    >
  >;
export type ListEinvoiceDocumentsApiV1AccountingInvoicesInvoiceIdEinvoiceDocumentsGetQueryError =
  HTTPValidationError;

export function useListEinvoiceDocumentsApiV1AccountingInvoicesInvoiceIdEinvoiceDocumentsGet<
  TData = Awaited<
    ReturnType<
      typeof listEinvoiceDocumentsApiV1AccountingInvoicesInvoiceIdEinvoiceDocumentsGet
    >
  >,
  TError = HTTPValidationError
>(
  invoiceId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listEinvoiceDocumentsApiV1AccountingInvoicesInvoiceIdEinvoiceDocumentsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listEinvoiceDocumentsApiV1AccountingInvoicesInvoiceIdEinvoiceDocumentsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listEinvoiceDocumentsApiV1AccountingInvoicesInvoiceIdEinvoiceDocumentsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListEinvoiceDocumentsApiV1AccountingInvoicesInvoiceIdEinvoiceDocumentsGet<
  TData = Awaited<
    ReturnType<
      typeof listEinvoiceDocumentsApiV1AccountingInvoicesInvoiceIdEinvoiceDocumentsGet
    >
  >,
  TError = HTTPValidationError
>(
  invoiceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listEinvoiceDocumentsApiV1AccountingInvoicesInvoiceIdEinvoiceDocumentsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listEinvoiceDocumentsApiV1AccountingInvoicesInvoiceIdEinvoiceDocumentsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listEinvoiceDocumentsApiV1AccountingInvoicesInvoiceIdEinvoiceDocumentsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListEinvoiceDocumentsApiV1AccountingInvoicesInvoiceIdEinvoiceDocumentsGet<
  TData = Awaited<
    ReturnType<
      typeof listEinvoiceDocumentsApiV1AccountingInvoicesInvoiceIdEinvoiceDocumentsGet
    >
  >,
  TError = HTTPValidationError
>(
  invoiceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listEinvoiceDocumentsApiV1AccountingInvoicesInvoiceIdEinvoiceDocumentsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Einvoice Documents
 */

export function useListEinvoiceDocumentsApiV1AccountingInvoicesInvoiceIdEinvoiceDocumentsGet<
  TData = Awaited<
    ReturnType<
      typeof listEinvoiceDocumentsApiV1AccountingInvoicesInvoiceIdEinvoiceDocumentsGet
    >
  >,
  TError = HTTPValidationError
>(
  invoiceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listEinvoiceDocumentsApiV1AccountingInvoicesInvoiceIdEinvoiceDocumentsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListEinvoiceDocumentsApiV1AccountingInvoicesInvoiceIdEinvoiceDocumentsGetQueryOptions(
      invoiceId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Download the stored e-invoice XML for an invoice (latest document).
 * @summary Download Einvoice Xml
 */
export const downloadEinvoiceXmlApiV1AccountingInvoicesInvoiceIdEinvoiceXmlGet =
  (invoiceId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/accounting/invoices/${invoiceId}/einvoice/xml`,
      method: 'GET',
      signal
    });
  };

export const getDownloadEinvoiceXmlApiV1AccountingInvoicesInvoiceIdEinvoiceXmlGetQueryKey =
  (invoiceId?: string) => {
    return [`/api/v1/accounting/invoices/${invoiceId}/einvoice/xml`] as const;
  };

export const getDownloadEinvoiceXmlApiV1AccountingInvoicesInvoiceIdEinvoiceXmlGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof downloadEinvoiceXmlApiV1AccountingInvoicesInvoiceIdEinvoiceXmlGet
      >
    >,
    TError = HTTPValidationError
  >(
    invoiceId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof downloadEinvoiceXmlApiV1AccountingInvoicesInvoiceIdEinvoiceXmlGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getDownloadEinvoiceXmlApiV1AccountingInvoicesInvoiceIdEinvoiceXmlGetQueryKey(
        invoiceId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof downloadEinvoiceXmlApiV1AccountingInvoicesInvoiceIdEinvoiceXmlGet
        >
      >
    > = ({ signal }) =>
      downloadEinvoiceXmlApiV1AccountingInvoicesInvoiceIdEinvoiceXmlGet(
        invoiceId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!invoiceId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof downloadEinvoiceXmlApiV1AccountingInvoicesInvoiceIdEinvoiceXmlGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type DownloadEinvoiceXmlApiV1AccountingInvoicesInvoiceIdEinvoiceXmlGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof downloadEinvoiceXmlApiV1AccountingInvoicesInvoiceIdEinvoiceXmlGet
      >
    >
  >;
export type DownloadEinvoiceXmlApiV1AccountingInvoicesInvoiceIdEinvoiceXmlGetQueryError =
  HTTPValidationError;

export function useDownloadEinvoiceXmlApiV1AccountingInvoicesInvoiceIdEinvoiceXmlGet<
  TData = Awaited<
    ReturnType<
      typeof downloadEinvoiceXmlApiV1AccountingInvoicesInvoiceIdEinvoiceXmlGet
    >
  >,
  TError = HTTPValidationError
>(
  invoiceId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof downloadEinvoiceXmlApiV1AccountingInvoicesInvoiceIdEinvoiceXmlGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof downloadEinvoiceXmlApiV1AccountingInvoicesInvoiceIdEinvoiceXmlGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof downloadEinvoiceXmlApiV1AccountingInvoicesInvoiceIdEinvoiceXmlGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useDownloadEinvoiceXmlApiV1AccountingInvoicesInvoiceIdEinvoiceXmlGet<
  TData = Awaited<
    ReturnType<
      typeof downloadEinvoiceXmlApiV1AccountingInvoicesInvoiceIdEinvoiceXmlGet
    >
  >,
  TError = HTTPValidationError
>(
  invoiceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof downloadEinvoiceXmlApiV1AccountingInvoicesInvoiceIdEinvoiceXmlGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof downloadEinvoiceXmlApiV1AccountingInvoicesInvoiceIdEinvoiceXmlGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof downloadEinvoiceXmlApiV1AccountingInvoicesInvoiceIdEinvoiceXmlGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDownloadEinvoiceXmlApiV1AccountingInvoicesInvoiceIdEinvoiceXmlGet<
  TData = Awaited<
    ReturnType<
      typeof downloadEinvoiceXmlApiV1AccountingInvoicesInvoiceIdEinvoiceXmlGet
    >
  >,
  TError = HTTPValidationError
>(
  invoiceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof downloadEinvoiceXmlApiV1AccountingInvoicesInvoiceIdEinvoiceXmlGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Download Einvoice Xml
 */

export function useDownloadEinvoiceXmlApiV1AccountingInvoicesInvoiceIdEinvoiceXmlGet<
  TData = Awaited<
    ReturnType<
      typeof downloadEinvoiceXmlApiV1AccountingInvoicesInvoiceIdEinvoiceXmlGet
    >
  >,
  TError = HTTPValidationError
>(
  invoiceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof downloadEinvoiceXmlApiV1AccountingInvoicesInvoiceIdEinvoiceXmlGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getDownloadEinvoiceXmlApiV1AccountingInvoicesInvoiceIdEinvoiceXmlGetQueryOptions(
      invoiceId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Dry-run: report what (if anything) would stop this invoice being issued.

Does not require the channel to be enabled — a tenant evaluating e-invoicing
needs to see what it would have to fix first. Never mutates.
 * @summary Validate Einvoice
 */
export const validateEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoiceValidatePost =
  (invoiceId: string, signal?: AbortSignal) => {
    return customInstance<EInvoiceValidationResponse>({
      url: `/api/v1/accounting/invoices/${invoiceId}/einvoice/validate`,
      method: 'POST',
      signal
    });
  };

export const getValidateEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoiceValidatePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof validateEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoiceValidatePost
        >
      >,
      TError,
      { invoiceId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof validateEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoiceValidatePost
      >
    >,
    TError,
    { invoiceId: string },
    TContext
  > => {
    const mutationKey = [
      'validateEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoiceValidatePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof validateEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoiceValidatePost
        >
      >,
      { invoiceId: string }
    > = (props) => {
      const { invoiceId } = props ?? {};

      return validateEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoiceValidatePost(
        invoiceId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ValidateEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoiceValidatePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof validateEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoiceValidatePost
      >
    >
  >;

export type ValidateEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoiceValidatePostMutationError =
  HTTPValidationError;

/**
 * @summary Validate Einvoice
 */
export const useValidateEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoiceValidatePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof validateEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoiceValidatePost
          >
        >,
        TError,
        { invoiceId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof validateEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoiceValidatePost
      >
    >,
    TError,
    { invoiceId: string },
    TContext
  > => {
    const mutationOptions =
      getValidateEinvoiceApiV1AccountingInvoicesInvoiceIdEinvoiceValidatePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Return a customer's e-invoicing profile (``data`` null when none exists).
 * @summary Get Einvoice Customer Profile
 */
export const getEinvoiceCustomerProfileApiV1AccountingInvoicesEinvoiceCustomerProfilesOrganizationIdGet =
  (organizationId: string, signal?: AbortSignal) => {
    return customInstance<EInvoiceCustomerProfileResponse>({
      url: `/api/v1/accounting/invoices/einvoice/customer-profiles/${organizationId}`,
      method: 'GET',
      signal
    });
  };

export const getGetEinvoiceCustomerProfileApiV1AccountingInvoicesEinvoiceCustomerProfilesOrganizationIdGetQueryKey =
  (organizationId?: string) => {
    return [
      `/api/v1/accounting/invoices/einvoice/customer-profiles/${organizationId}`
    ] as const;
  };

export const getGetEinvoiceCustomerProfileApiV1AccountingInvoicesEinvoiceCustomerProfilesOrganizationIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getEinvoiceCustomerProfileApiV1AccountingInvoicesEinvoiceCustomerProfilesOrganizationIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    organizationId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getEinvoiceCustomerProfileApiV1AccountingInvoicesEinvoiceCustomerProfilesOrganizationIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetEinvoiceCustomerProfileApiV1AccountingInvoicesEinvoiceCustomerProfilesOrganizationIdGetQueryKey(
        organizationId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getEinvoiceCustomerProfileApiV1AccountingInvoicesEinvoiceCustomerProfilesOrganizationIdGet
        >
      >
    > = ({ signal }) =>
      getEinvoiceCustomerProfileApiV1AccountingInvoicesEinvoiceCustomerProfilesOrganizationIdGet(
        organizationId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!organizationId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getEinvoiceCustomerProfileApiV1AccountingInvoicesEinvoiceCustomerProfilesOrganizationIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetEinvoiceCustomerProfileApiV1AccountingInvoicesEinvoiceCustomerProfilesOrganizationIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getEinvoiceCustomerProfileApiV1AccountingInvoicesEinvoiceCustomerProfilesOrganizationIdGet
      >
    >
  >;
export type GetEinvoiceCustomerProfileApiV1AccountingInvoicesEinvoiceCustomerProfilesOrganizationIdGetQueryError =
  HTTPValidationError;

export function useGetEinvoiceCustomerProfileApiV1AccountingInvoicesEinvoiceCustomerProfilesOrganizationIdGet<
  TData = Awaited<
    ReturnType<
      typeof getEinvoiceCustomerProfileApiV1AccountingInvoicesEinvoiceCustomerProfilesOrganizationIdGet
    >
  >,
  TError = HTTPValidationError
>(
  organizationId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEinvoiceCustomerProfileApiV1AccountingInvoicesEinvoiceCustomerProfilesOrganizationIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getEinvoiceCustomerProfileApiV1AccountingInvoicesEinvoiceCustomerProfilesOrganizationIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getEinvoiceCustomerProfileApiV1AccountingInvoicesEinvoiceCustomerProfilesOrganizationIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetEinvoiceCustomerProfileApiV1AccountingInvoicesEinvoiceCustomerProfilesOrganizationIdGet<
  TData = Awaited<
    ReturnType<
      typeof getEinvoiceCustomerProfileApiV1AccountingInvoicesEinvoiceCustomerProfilesOrganizationIdGet
    >
  >,
  TError = HTTPValidationError
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEinvoiceCustomerProfileApiV1AccountingInvoicesEinvoiceCustomerProfilesOrganizationIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getEinvoiceCustomerProfileApiV1AccountingInvoicesEinvoiceCustomerProfilesOrganizationIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getEinvoiceCustomerProfileApiV1AccountingInvoicesEinvoiceCustomerProfilesOrganizationIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetEinvoiceCustomerProfileApiV1AccountingInvoicesEinvoiceCustomerProfilesOrganizationIdGet<
  TData = Awaited<
    ReturnType<
      typeof getEinvoiceCustomerProfileApiV1AccountingInvoicesEinvoiceCustomerProfilesOrganizationIdGet
    >
  >,
  TError = HTTPValidationError
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEinvoiceCustomerProfileApiV1AccountingInvoicesEinvoiceCustomerProfilesOrganizationIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Einvoice Customer Profile
 */

export function useGetEinvoiceCustomerProfileApiV1AccountingInvoicesEinvoiceCustomerProfilesOrganizationIdGet<
  TData = Awaited<
    ReturnType<
      typeof getEinvoiceCustomerProfileApiV1AccountingInvoicesEinvoiceCustomerProfilesOrganizationIdGet
    >
  >,
  TError = HTTPValidationError
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEinvoiceCustomerProfileApiV1AccountingInvoicesEinvoiceCustomerProfilesOrganizationIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetEinvoiceCustomerProfileApiV1AccountingInvoicesEinvoiceCustomerProfilesOrganizationIdGetQueryOptions(
      organizationId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create or update a customer's e-invoicing profile.

Only the fields present in the body are written, so a partial update never
blanks a field the caller didn't mention.
 * @summary Upsert Einvoice Customer Profile
 */
export const upsertEinvoiceCustomerProfileApiV1AccountingInvoicesEinvoiceCustomerProfilesOrganizationIdPut =
  (
    organizationId: string,
    eInvoiceCustomerProfileUpdateRequest: EInvoiceCustomerProfileUpdateRequest
  ) => {
    return customInstance<EInvoiceCustomerProfileResponse>({
      url: `/api/v1/accounting/invoices/einvoice/customer-profiles/${organizationId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: eInvoiceCustomerProfileUpdateRequest
    });
  };

export const getUpsertEinvoiceCustomerProfileApiV1AccountingInvoicesEinvoiceCustomerProfilesOrganizationIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof upsertEinvoiceCustomerProfileApiV1AccountingInvoicesEinvoiceCustomerProfilesOrganizationIdPut
        >
      >,
      TError,
      { organizationId: string; data: EInvoiceCustomerProfileUpdateRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof upsertEinvoiceCustomerProfileApiV1AccountingInvoicesEinvoiceCustomerProfilesOrganizationIdPut
      >
    >,
    TError,
    { organizationId: string; data: EInvoiceCustomerProfileUpdateRequest },
    TContext
  > => {
    const mutationKey = [
      'upsertEinvoiceCustomerProfileApiV1AccountingInvoicesEinvoiceCustomerProfilesOrganizationIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof upsertEinvoiceCustomerProfileApiV1AccountingInvoicesEinvoiceCustomerProfilesOrganizationIdPut
        >
      >,
      { organizationId: string; data: EInvoiceCustomerProfileUpdateRequest }
    > = (props) => {
      const { organizationId, data } = props ?? {};

      return upsertEinvoiceCustomerProfileApiV1AccountingInvoicesEinvoiceCustomerProfilesOrganizationIdPut(
        organizationId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpsertEinvoiceCustomerProfileApiV1AccountingInvoicesEinvoiceCustomerProfilesOrganizationIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof upsertEinvoiceCustomerProfileApiV1AccountingInvoicesEinvoiceCustomerProfilesOrganizationIdPut
      >
    >
  >;
export type UpsertEinvoiceCustomerProfileApiV1AccountingInvoicesEinvoiceCustomerProfilesOrganizationIdPutMutationBody =
  EInvoiceCustomerProfileUpdateRequest;
export type UpsertEinvoiceCustomerProfileApiV1AccountingInvoicesEinvoiceCustomerProfilesOrganizationIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Upsert Einvoice Customer Profile
 */
export const useUpsertEinvoiceCustomerProfileApiV1AccountingInvoicesEinvoiceCustomerProfilesOrganizationIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof upsertEinvoiceCustomerProfileApiV1AccountingInvoicesEinvoiceCustomerProfilesOrganizationIdPut
          >
        >,
        TError,
        { organizationId: string; data: EInvoiceCustomerProfileUpdateRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof upsertEinvoiceCustomerProfileApiV1AccountingInvoicesEinvoiceCustomerProfilesOrganizationIdPut
      >
    >,
    TError,
    { organizationId: string; data: EInvoiceCustomerProfileUpdateRequest },
    TContext
  > => {
    const mutationOptions =
      getUpsertEinvoiceCustomerProfileApiV1AccountingInvoicesEinvoiceCustomerProfilesOrganizationIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
